import axios from 'axios'

export default {
    async create (data) {
      try {
        const response = await axios.post(`/admin/drivers`, data)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async update (driver, data) {
      try {
        const response = await axios.patch(`/admin/drivers/${driver}`, data)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async destroy (driver) {
      try {
        const response = await axios.delete(`/admin/drivers/${driver}`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async sync (driver) {
      try {
        const response = await axios.post(`/admin/drivers/${driver}/sync`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async createVersion (driver, data) {
      try {
        const response = await axios.post(`/admin/drivers/${driver}/versions`, data)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async setDefaultVersion (driver, version) {
      try {
        const response = await axios.patch(`/admin/drivers/${driver}`, {
          default_version_id: version.id
        })
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async setDefaultDriver (driver) {
      try {
        const response = await axios.patch(`/admin/drivers/${driver.id}/set-default`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async deleteAllUnUsedDrivers(driver)
    {
      try {
          const response = await axios.delete(`/admin/drivers/${driver}/delete-unused`)
          return _.get(response, 'data')
      } catch (err) {
          console.error(err)
          return _.get(err, 'data', false)
      }
    }  
}
